import { ConfirmationModal, useModal } from '@europrocurement/flexy-components';
import React, { useEffect } from 'react';
import { PaletteColor, useTheme } from '@mui/material';
import JustificationModal from '../JustificationModal/JustificationModal';

export type ChangeDossierStatusModalProps = {
    title: string;
    description: string;
    showModal: boolean;
    withJustification: boolean;
    paletteColor?: PaletteColor;
    onConfirm: (message?: string) => void;
    onClose: () => void;
};

const ChangeDossierStatusModal: React.FunctionComponent<ChangeDossierStatusModalProps> = function (
    props,
) {
    const { palette } = useTheme();
    const {
        title,
        description,
        showModal,
        withJustification,
        paletteColor = palette.warning,
        onConfirm,
        onClose,
    } = props;
    const { modalStatus, modalActions } = useModal();

    let modal;

    if (withJustification) {
        modal = (
            <JustificationModal
                title={title}
                description={description}
                required={false}
                onConfirm={onConfirm}
                onCancel={onClose}
            />
        );
    } else {
        modal = (
            <ConfirmationModal
                messages={{
                    question: title,
                    detail: {
                        message: description,
                        severity: 'warning',
                    },
                }}
                actionOnValidation={() => {
                    onConfirm();
                }}
                actionOnCancellation={onClose}
                color={paletteColor}
            />
        );
    }

    useEffect(() => {
        if (showModal) {
            modalActions.call(modal);
        } else {
            modalActions.close();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showModal]);

    useEffect(() => {
        if (!modalStatus.isOpen) {
            onClose();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modalStatus.isOpen]);

    return null;
};

export default ChangeDossierStatusModal;
